import { $, $$, insertHTML } from 'utils/dom';
import { APILazerLoader } from 'modules/lazer-loader';
import { getApi, Plyr } from 'modules/Plyr/create-plyr';

export const buildPlayer = async (api, container) => {
  const $video = $('.video-placeholder', container);
  const $videoIframe = $('.plyr-player', container);

  if ($video) {
    const captions = [...$video.childNodes].filter(
      el => el.nodeName === 'TRACK'
    );
    const { poster, src, type } = $video.dataset;
    const videoMarkup = `<video class="glidebox__video video-player" playsinline></video>`;

    // create video-tag
    insertHTML(container, 'beforeend', videoMarkup);

    const videoplayer = $('.video-player', container);
    captions.forEach(c => videoplayer.appendChild(c));

    // set poster
    poster && videoplayer.setAttribute('poster', poster);

    // set src
    if (src) {
      insertHTML(
        videoplayer,
        'beforeend',
        `<source src="${src}" type="${type}">`
      );
    }

    const pl = new Plyr(api, videoplayer, {});
    const player = await pl.create();
    player.on('ready', () => {
      container.classList.add('is-ready');
    });
  }

  if ($videoIframe) {
    const poster = $videoIframe.dataset.poster;
    const $audio = $('.plyr-player--audio', container);
    const modalOpenClose = $$(
      '.audioguide-map__modalclose, .audioguide-map__modalopen, .pop-up__close'
    );

    const pl = new Plyr(api, $videoIframe, {
      hideControls: !$audio,
    });

    const player = await pl.create();
    player.on('ready', () => {
      poster && (player.poster = poster);
      container.classList.add('is-ready');
      if ($audio) {
        container.classList.add('is-audio');
      }
      // pause player in audioguide when modal is closed
      if (modalOpenClose.length) {
        modalOpenClose.forEach(button => {
          button.addEventListener('click', () => {
            player.pause();
          });
        });
      }
    });
  }
};

export const observe = targets => {
  new APILazerLoader({
    targets,
    config: {
      rootMargin: '50px 0px',
      threshold: 0.01,
    },
    cb: (api, { target }) => buildPlayer(api, target),
    loadAPI: () => getApi(),
  }).init();
};

const $$videos = $$('.plyr-wrapper');
$$videos.length && observe($$videos);
